import {createPinia} from "pinia";

let pinia = createPinia()

export default pinia